import { useSwiperSlide } from "swiper/react";
import { audio_click } from "../lib/SoundManager";
import React from "react";

export default function App() {
  const swiperSlide = useSwiperSlide();
  
  if (!swiperSlide.isActive) {
    return <></>;
  }
  return (
    <>
      <img
        style={{
          position: "absolute",
          top: "76px",
          left: "121px",
        }}
        src="images/02/02/subtitle.png"
      ></img>
      <img
        onClick={() => {
          audio_click();
          window.open("https://www.tutorialspoint.com/unix/index.htm");
        }}
        style={{
          position: "absolute",
          top: "180px",
          left: "110px",
          cursor: "pointer",
        }}
        src="images/02/02/btn_1.png"
      />
       <img
        onClick={() => {
          audio_click();
          window.open("https://docs.oracle.com/en/operating-systems/oracle-linux/6/admin/configure-nis-server.html");
        }}
        style={{
          position: "absolute",
          top: "180px",
          left: "530px",
          cursor: "pointer",
        }}
        src="images/02/02/btn_2.png"
      />
      <img
        onClick={() => {
          audio_click();
          window.open("https://docs.oracle.com/ko/learn/create_nfs_linux/#objectives");
        }}
        style={{
          position: "absolute",
          top: "180px",
          left: "950px",
          cursor: "pointer",
        }}
        src="images/02/02/btn_3.png"
      />
    </>
  );
}
